import PublicRouteOwner from '../../routes/PublicRouteOwner';
import OwnerSendOtp from '../../pages/owner/auth/SendOtp';

/**
 * Handles root path for owner - either normal signup/login or Foodics OAuth callback
 * If flowId exists in URL: owner is returning from Foodics OAuth (OwnerSendOtp handles it)
 * Otherwise: normal owner signup/login
 */
const FoodicsCallbackRedirect = () => {
    return (
        <PublicRouteOwner>
            <OwnerSendOtp />
        </PublicRouteOwner>
    );
};

export default FoodicsCallbackRedirect;
